/*
 * Copyright 2020 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  MissingAnnotationEmptyState,
  useEntity,
} from '@backstage/plugin-catalog-react';
import { useRoutes } from 'react-router';

import { MkDocsPage } from '../components/MkDocsPage/MkDocsPage';

const TECHDOCS_ANNOTATION = 'backstage.io/techdocs-ref';
const TECHDOCS_EXTERNAL_ANNOTATION = 'backstage.io/techdocs-entity';

/**
 * Responsible for registering route to view docs on Entity page
 *
 * @public
 */
export const EmbeddedDocsRouter = () => {
  const { entity } = useEntity();

  // Using objects instead of <Route> elements, otherwise "outlet" will be null on sub-pages and add-ons won't render
  const element = useRoutes([
    {
      children: [
        {
          element: <>ignored</>,
          path: '*',
        },
      ],
      element: <MkDocsPage padding={24} />,
      path: '/*',
    },
  ]);

  const projectId =
    entity.metadata.annotations?.[TECHDOCS_ANNOTATION]
    ?? entity.metadata.annotations?.[TECHDOCS_EXTERNAL_ANNOTATION];

  if (!projectId) {
    return <MissingAnnotationEmptyState annotation={[TECHDOCS_ANNOTATION]} />;
  }

  return element;
};
